import { WebhookEvents } from '../enums';

export const WEBHOOK_EVENTS_LIST = [
  WebhookEvents.partyCreated,
  WebhookEvents.partyUpdated,
  WebhookEvents.partyCheckedIn,
  WebhookEvents.partyMarked,
];
